import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
// tslint:disable: quotemark

@Component
export default class ProjectStatusMixin extends Mixins(PrivilegeMixin) {
  public projectEventTypeNames = {
    1: 'Op te meten',
    2: 'Uit te voeren',
    3: 'In Uitvoering',
    4: 'Uitgevoerd',
    5: 'Afgesloten'
  };

  public projectEventTypeColors = {
    1: 'undefined',
    2: 'primary',
    3: 'primary',
    4: 'success',
    5: 'success'
  };

  public projectStatusOptionList = [
    {
      value: null,
      text: 'Toon alle'
    },
    {
      value: 1,
      text: this.projectEventTypeNames[1]
    },
    {
      value: 2,
      text: this.projectEventTypeNames[2]
    },
    {
      value: 3,
      text: this.projectEventTypeNames[3]
    },
    {
      value: 4,
      text: this.projectEventTypeNames[4]
    },
    {
      value: 5,
      text: this.projectEventTypeNames[5]
    }
  ];

  public projectEventTypeOptionList = [
    {
      value: 1,
      text: this.projectEventTypeNames[1]
    },
    {
      value: 2,
      text: this.projectEventTypeNames[2]
    },
    {
      value: 3,
      text: this.projectEventTypeNames[3]
    },
    {
      value: 4,
      text: this.projectEventTypeNames[4]
    },
    {
      value: 5,
      text: this.projectEventTypeNames[5]
    }
  ];
}
